import React from "react";
import { Container } from "@mui/material";
import { Box, Button, Grid, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import Sella from "./Sella.png";
import axios from "axios";
import Url from "../services/Url";
import { useState, useEffect } from "react";
import { useSharedStore } from "../services/SharedStore";
import goal from "./goal.png";
import "../cssPages/Logo.css";
import "../cssPages/Line.css";

const SimpleBox2 = styled(Box)({
  textAlign: "center",
  marginTop: "36px"
});

const SimpleBox = styled(Box)({
  textAlign: "center",
  marginTop: "3px"
});

const SendEmailButton = styled(Button)({
  fontFamily: "Lato",
  fontSize: "16px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  color: "#339aef",
  textTransform: "none",
});

const Intestazione = styled(Box)({
  fontFamily: "Montserrat, sans-serif",
  fontSize: "31px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});

const CompilaCampi = styled(Box)({
  marginTop: "10px",
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  textAlign: "center",
  color: "#7b7b7b",
});

const YourCode = styled(Box)({
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.13px",
  textAlign: "center",
  color: "#4d606f",
});

const Codes = styled(Box)({
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  display: "flex",
  justifyContent: "center",
  lineHeight: "normal",
  letterSpacing: "0.13px",
  color: "#4d606f",
});

const HelperText = styled(Box)({
  marginTop: "168px",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#919191",
});

const ContactLink = styled(Link)({
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#00cb4d",
});

const Informativa = styled(Box)({
  marginBottom: '36px',
  opacity: "0.5",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#333",
});

const ResponseSendCodes = styled(Box)({
  fontFamily: 'Lato',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.13px',
  textAlign: 'center',
  color: '#4d606f'
});

const CheckImg = styled(Grid)({

});

function PrintCodeForm() {
  const [loading, setloading] = useState(false);
  const [codes, setCodes] = useState([]);
  const [message, setMessage] = useState("I tuoi Codici Cliente sono:");
  const { getStore, getStoreAsync } = useSharedStore();
  const [sendCodesResponse, setSendCodesResponse] = useState("");
  const [responseCode, setResponseCode] = useState("");



  const getCodes = () => {
    setloading(true);
    getStoreAsync("token").then(val => {
      axios.get(Url + "api/getcode", {
        headers: {
          'Authorization': val
        }
      }).then(res => {
        setloading(false);
        if (res.data.response_code != "CR_3_30") {
          setMessage(res.data.response_desc);
        } else {
          setCodes(res.data.response_data);
        }
      })
    })
  }

  useEffect(() => {
    setloading(false);
    window.scrollTo(0, 0);
    getCodes();
  }, []);

  const sendCodes = () => {
    setloading(true);
    axios.get(Url + "api/sendcode", {
      headers: {
        'Authorization': getStore("token")
      }
    }).then(res => {
      setloading(false);
      setResponseCode(res.data.response_code);
      setSendCodesResponse(res.data.response_desc);
    })
  }

  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <Container maxWidth="1">
      <Grid container>
        <Grid class="logoContainer" item xs={12} sm={12} md={12}>
          <img class="logo" src={Sella}></img>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <CompilaCampi>
            Compila i campi per recuperare il Codice Cliente o Username
          </CompilaCampi>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-2"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <CheckImg container>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <center>
            <img class="check2" src={goal}></img>
          </center>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </CheckImg>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <YourCode>{message}</YourCode>
        </Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Codes>
            <ul>
              {codes.map((option) => (
                <li>
                  {option}
                </li>
              ))}
            </ul>
          </Codes>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          {responseCode != "CR_3_40" &&
            <SimpleBox2>
              <SendEmailButton
                disabled={loading}
                onClick={sendCodes}
              >Inviami i codici via email</SendEmailButton>
            </SimpleBox2>}

          <ResponseSendCodes dangerouslySetInnerHTML={{ __html: sendCodesResponse }}>

          </ResponseSendCodes>
          <Grid item xs={0} sm={0} md={4}></Grid>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <HelperText>
            Vuoi maggiori informazioni o hai bisogno di assistenza?
          </HelperText>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-1"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Informativa>
            © 1996-{currentYear} - Banca Sella S.p.A. - PI 02224410023 - Privacy
          </Informativa>
        </Grid>
      </Grid>
    </Container>
  );
}

export default PrintCodeForm;
